import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Alert
} from '@mui/material';
import {
  Delete as DeleteIcon
} from '@mui/icons-material';
import dayjs from 'dayjs';

const DeleteConfirmationDialog = ({ 
  open, 
  onClose, 
  bookingToDelete, 
  onConfirmDelete 
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmer la suppression</DialogTitle>
      <DialogContent>
        <Typography>
          Êtes-vous sûr de vouloir supprimer cette réservation ?
        </Typography>
        {bookingToDelete && (
          <Box mt={2} p={2} bgcolor="grey.100" borderRadius={1}>
            <Typography variant="body2">
              <strong>Client:</strong> {bookingToDelete.clientName}
            </Typography>
            <Typography variant="body2">
              <strong>Service:</strong> {bookingToDelete.service}
            </Typography>
            <Typography variant="body2">
              <strong>Date:</strong> {dayjs(bookingToDelete.date).format('DD/MM/YYYY à HH:mm')}
            </Typography>
          </Box>
        )}
        <Alert severity="warning" sx={{ mt: 2 }}>
          Cette action est irréversible.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>
        <Button
          onClick={onConfirmDelete}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;